import { defineStore } from "pinia";
import router from "@/router";
import { useAlertStore, useErrorStore } from "@/store";
import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL;

export const useAuthStore = defineStore({
  id: "auth",
  state: () => ({
    // user: JSON.parse(localStorage.getItem("auth")),
    user: JSON.parse(localStorage.getItem("user")),
    tokens: JSON.parse(localStorage.getItem("token")),
    returnUrl: null,
  }),
  actions: {
    async login(username, password) {
      try {
        let user = await axios.post(baseUrl + "auth/login", {
          username: username,
          password: password,
        });
        this.user = user.data.user;
        localStorage.setItem("user", JSON.stringify(user.data.user));
        localStorage.setItem("token", JSON.stringify(user.data.tokens));

        window.location.reload();
        router.push(this.returnUrl || "/");
      } catch (error) {
        console.log(error);
        if (error) {
          const alertStore = useAlertStore();
          alertStore.error(error);
        } else {
          this.result = {};
          const errorMessage = useErrorStore();
          errorMessage.open = true;
        }
      }
    },
    logout() {
      this.user = null;

      localStorage.removeItem("user");
      localStorage.removeItem("token");
      router.push("/login");
    },
    async refreshToken() {
      try {
        const newToken = await axios.post(baseUrl + "auth/refresh-tokens", {
          refreshToken: this.tokens.refresh.token,
        });
        const refresh = newToken.data;
        this.tokens = refresh;

        localStorage.setItem("token", JSON.stringify(refresh));
        return Promise.resolve();
      } catch (error) {
        console.log(error);
      }
    },
  },
});
